import introJs from "intro.js";
import CommonFunction from "@/utils/CommonFunction";


export function loadDriverSteps(setps) {
    let arr = [];

    for (let i = 0; i < setps.length; i++) {
        if (!localStorage.getItem(setps[i].targetValue)&&!localStorage.getItem(setps[i].targetValue.replaceAll('intro.',''))) {
            arr.push(setps[i]);
        }
    }
    if (arr.length > 0) {
        driver(arr)
    }
}







export function driver(steps = undefined) {
        if (!steps) {
            return;
        }
        let _this = this;
        introJs.tour()
            .setOptions({
                showButtons: true,
                showBullets: false,
                // tooltipClass: 'customTooltip',
                // highlightClass: 'customHighlight',
                // buttonClass: 'customButton',
                disableInteraction: true,
                scrollToElement: true,
                scrollTo: 'element',
                hidePrev: true,
                exitOnOverlayClick: false,
                exitOnEsc: false,
                autoPosition: true,
                overlayOpacity: .5,
                showProgress: true,
                showStepNumbers: true,
                stepNumbersOfLabel: '/',
                nextLabel: '下一步',
                prevLabel: '上一步',
                doneLabel: '明白了！',
                steps: steps
            }).onbeforechange(async function (targetElement) {
                let currentStep = steps[this.currentStep()];
                if (currentStep.hasOwnProperty('beforeAnmimationFun') && typeof currentStep.beforeAnmimationFun === 'function') {
                    currentStep.beforeAnmimationFun();
                }
                setTimeout(() =>{
                    return new Promise((resolve) => {
                        // 平滑滚动到目标元素
                        console.log(targetElement, this);

                        CommonFunction.smoothScrollToElement(targetElement).then(() => {
                            if (currentStep.hasOwnProperty('beforeFun') && typeof currentStep.beforeFun === 'function') {
                                currentStep.beforeFun();
                            }
                            resolve(); // 继续Intro.js流程
                        });
                    })
                },(currentStep.hasOwnProperty('beforeAnmimationFun')&&typeof currentStep.beforeAnmimationFun==='function')?1000:0)
            })
            //切换之后，获取的是切换之后的元素
            .onAfterChange( async function (element) {
                return new Promise((resolve) => {
                    let currentStep = steps[this.currentStep()];
                    if (currentStep.hasOwnProperty('afterFun') && typeof currentStep.afterFun === 'function') {
                        currentStep.afterFun();
                    }
                    localStorage.setItem(currentStep.targetValue, currentStep.targetValue);
                    resolve();
                })
            }).onSkip(function (param){
                console.log('skip',param)
            }).onChange(function (param) {
                console.log('change', param);
            })
            .onbeforeexit(function (target) {
                return true;
            }).start();


}

